import React, { Component } from 'react';
import './DeliveryOnlyContent.sass';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import ratings from '../ratings';
import FacebookIcon from '../../Icons/Facebook';
import TwitterIcon from '../../Icons/Twitter';
import bullet1 from './bullets-1.gif';
import bullet2 from './bullets-2.gif';
import bullet3 from './bullets-3.gif';

const SLIDER_SETTINGS = {
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 1000,
  centerMode: true,
  draggable: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 1
      }
    }
  ]
}
const SocialCard = ({ name, handle, message, type }) => {
  const icon = type === 'facebook' ? <FacebookIcon /> : <TwitterIcon />
  return (
    <div className="social-card">
      <div className="meta">
        <div className="name">{name}</div>
        <div className="handle">{handle}</div>
      </div>
      <div className="message">{message}</div>
      <div className="social-icon">{icon}</div>
    </div>
  )
}

SocialCard.propTypes = {
  name: PropTypes.string,
  handle: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.string
}

class DeliveryOnlyContent extends Component {
  render() {
    return (
        <div className="homepage-content">
          <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
          <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />

          <main>

              <div className="bullet-content">
                  <div className="bullet-content-flex">
                    <div className="bullet-img-wrapper">
                      <img className="bullet-img-1" src={bullet1} alt="" />
                    </div>

                    <div className="bullet-content-text">
                        <h2>Hot, fresh food</h2>
                        <p>Unlike the third party delivery apps, we’re not a middleman in the delivery process. We ARE the process. Our menu is cooked to-order by our chefs, in our kitchen, and delivered by the best couriers in the business.</p>
                    </div>
                  </div>

                  <div className="bullet-content-flex">
                    <div className="bullet-img-wrapper">
                      <img src={bullet2} alt="" />
                    </div>

                    <div className="bullet-content-text">
                        <h2>Something for everyone</h2>
                        <p>Polly wants pizza. Bill loves BBQ. Victor’s vegan. Delivery isn’t a compromise with ClusterTruck. Since we cook across multiple menus, we can satisfy everyone’s tastes and dietary needs.</p>
                    </div>
                  </div>

                  <div className="bullet-content-flex">
                    <div className="bullet-img-wrapper">
                      <img src={bullet3} alt="" />
                    </div>

                      <div className="bullet-content-text">
                          <h2>Convenient group ordering</h2>
                          <p>We make group ordering a breeze. <br/>
                          It’s easy for everyone to pay separately, or pay for the group. Even schedule your order to arrive when you want it. Best of all, delivery is free when ordered as a group.</p>
                      </div>
                  </div>
              </div>

              <h1 className="headline-divider">
                  The People Have Spoken <span role="img" aria-label="raised hands">🙌</span>
              </h1>

              <div className="social-cards">
                  <div className="social-card-inner">
                      <Slider {...SLIDER_SETTINGS}>
                      {ratings.map((rating, i) => {
                        return (
                          <div key={i}>
                            <SocialCard {...rating} />
                          </div>
                        )
                      })}
                      </Slider>
                  </div>
              </div>
          </main>
        </div>
    )
  }
}
DeliveryOnlyContent.propTypes = {
  onVideoLaunch: PropTypes.func.isRequired
};

export default DeliveryOnlyContent;
